import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../../assets/logo2.png";

const Header = () => {
  const [activeNavbar, setActiveNavbar] = useState(false);
  const [restaurantSelect, setRestaurantSelect] = useState("");
  const [foodSelect, setFoodSelect] = useState("");

  const navigate = useNavigate();

  const handleSelect = (e, type) => {
    const selectedPage = e.target.value;

    // Reset select values
    if (type === "restaurant") setRestaurantSelect("");
    else if (type === "food") setFoodSelect("");

    // Close hamburger menu
    setActiveNavbar(false);

    // Navigate
    if (selectedPage === "back") {
      window.history.back();
    } else if (selectedPage !== "") {
      navigate(selectedPage);
    }
  };

  const closeMenu = () => {
    setActiveNavbar(false);
  };

  return (
    <div className="header">
      {/* Logo */}
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Logo" />
        </Link>
      </div>

      {/* Navigation */}
      <div className="middle-section">
        <ul className={`navlinks ${activeNavbar ? "active" : ""}`}>
          <div className="middle-first">
            <Link className="navlink" to="/" onClick={closeMenu}>
              Home
            </Link>

            <Link className="navlink" to="/about" onClick={closeMenu}>
              About us
            </Link>

            {/* Restaurant Dropdown */}
            <div className="dropdown dropdown-first">
              <select
                onChange={(e) => handleSelect(e, "restaurant")}
                value={restaurantSelect}
                className="custom-select"
              >
                <option value="" disabled>
                  Restaurant
                </option>
                <option value="/dhaba">Dhaba</option>
              
              </select>
            </div>

            {/* Food Dropdown */}
            <div className="dropdown">
              <select
                onChange={(e) => handleSelect(e, "food")}
                value={foodSelect}
                className="custom-select food-menu"
              >
                <option value="" disabled>
                  Food
                </option>
                <option value="/streetfood">Streetfood</option>
               
              </select>
            </div>

            <Link
              className="navlink navlink-blog"
              to="/blog"
              onClick={closeMenu}
            >
              Blog
            </Link>
          </div>

          {/* Cart */}
          <div className="cart-section">
            <Link className="navlink cart-icon" to="/cart" onClick={closeMenu}>
              <i className="ri-shopping-cart-2-fill"></i>
            </Link>
          </div>
        </ul>
      </div>

      {/* Hamburger */}
      <div
        className={`hamburger ${activeNavbar ? "active" : ""}`}
        onClick={() => setActiveNavbar(!activeNavbar)}
      >
        <i className="ri-menu-3-fill"></i>
      </div>
    </div>
  );
};

export default Header;
